import { useState, useEffect } from 'react';
import Image from 'next/legacy/image';
import ImageWithZoom from './image-with-zoom';
import setImageSize from '../utils/setImageSize';

interface CloudImageProps {
  src: string;
  alt?: string;
}

// Standalone Cloudimage URLs used inside markdown (the Cloudimage plugin only
// outputs JSON for gallery fields, so inline images are passed here as a plain
// pre-optimized cloudimg.io URL, e.g. https://xxx.cloudimg.io/...?vh=...).
const CloudImage: React.FunctionComponent<CloudImageProps> = ({ src, alt }) => {
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setImageSize(setImageDimensions, src);
  }, [src]);

  if (!src || !imageDimensions.width) {
    return null;
  }

  if (imageDimensions.width > 800) {
    return (
      <div className="image-wrapper">
        <ImageWithZoom src={src} alt={alt} width={imageDimensions.width} height={imageDimensions.height} />
      </div>
    );
  }

  return (
    <div className="image-wrapper">
      <Image
        src={src}
        alt={alt || ''}
        width={imageDimensions.width}
        height={imageDimensions.height}
        layout="intrinsic"
        quality={100}
      />
    </div>
  );
};

export default CloudImage;
